import type { components } from '@adiox/api';

export type HistorySummary = components['schemas']['HistorySummary'];

export interface SummaryItem {
  id: 'profit' | 'commission' | 'swap' | 'net' | 'deposits' | 'withdrawals' | 'credit' | 'balance';
  label: string;
  value: number;
  /** Colour by sign (results), or none (plain amounts). */
  signed: boolean;
}

/**
 * The totals line under the History filters, like MT5's: Profit, Commission, Swap and Net of the trades in the period, then the
 * money moved in and out (only when the period is not narrowed to one symbol, since balance operations have no symbol),
 * and the account's balance now.
 */
export function summaryItems(s: HistorySummary, bySymbol: boolean, balance: number | null): SummaryItem[] {
  const items: SummaryItem[] = [
    { id: 'profit', label: 'Profit', value: s.profit, signed: true },
    { id: 'commission', label: 'Commission', value: s.commission, signed: true },
    { id: 'swap', label: 'Swap', value: s.swap, signed: true },
    { id: 'net', label: 'Net result', value: s.profit + s.commission + s.swap, signed: true },
  ];
  if (!bySymbol) {
    items.push(
      { id: 'deposits', label: 'Deposits', value: s.deposits, signed: false },
      { id: 'withdrawals', label: 'Withdrawals', value: s.withdrawals, signed: false },
      { id: 'credit', label: 'Credit', value: s.credit, signed: false },
    );
  }
  if (balance !== null) items.push({ id: 'balance', label: 'Balance now', value: balance, signed: false });
  return items;
}
